export default "__VITE_ASSET__a171cd3f__"